import { render } from "./telephoneInspection.vue?vue&type=template&id=a012b57e&scoped=true"
import script from "./telephoneInspection.vue?vue&type=script&lang=js"
export * from "./telephoneInspection.vue?vue&type=script&lang=js"

import "./telephoneInspection.vue?vue&type=style&index=0&id=a012b57e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a012b57e"

export default script